import React from 'react';
import ReactDOM from 'react-dom/client';
import { GlobalStyle } from './globalStyle';
import { Routes } from './Routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <Routes />
  </React.StrictMode>
);
